import React from 'react';
import { observer } from '../../shared/observer';
import { isActiveOrder } from '../../shared/orderStatus';
import { ActiveOrderList } from './ActiveOrders';

// Значок текущих заказов в шапке сайта: иконка с количеством, по клику —
// шторка с теми же компактными карточками, что показывает клиентское
// приложение на главном экране (CurrentOrdersList).
//
// Источник данных — mobile_token.current_orders из bootstrap (POST v3/tokens):
// ровно то же, что читает приложение (authStore.currentOrders), поэтому
// значок не стоит ни одного дополнительного запроса. Сервер уже отдаёт там
// только текущие заказы (Client#current_orders), isActiveOrder — страховка,
// как и фильтр по терминальным статусам в приложении.
class HeaderOrdersView extends React.Component {
  state = { open: false };

  componentDidMount() {
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKeyDown);
  }

  // Клик мимо шторки закрывает её. Слушатель на document, потому что шапка
  // рисуется на любой странице сайта и своего оверлея у неё нет.
  onDocClick = (e) => {
    if (!this.state.open) return;
    if (this.node && this.node.contains(e.target)) return;
    this.setState({ open: false });
  };

  onKeyDown = (e) => {
    if (e.key === 'Escape' && this.state.open) this.setState({ open: false });
  };

  setNode = (node) => { this.node = node; };

  toggle = (e) => {
    e.preventDefault();
    this.setState((st) => ({ open: !st.open }));
  };

  render() {
    const token = this.props.auth.mobileToken || {};
    const list = (token.current_orders || []).filter(isActiveOrder);
    // Нет текущих заказов — значка нет вовсе, шапку не засоряем.
    if (!list.length) return null;

    const { open } = this.state;

    return (
      <div className="ng-header__orders-wrap" ref={this.setNode}>
        <a
          className={'ng-header__orders' + (open ? ' is-open' : '')}
          href="/profile#orders"
          onClick={this.toggle}
          aria-expanded={open ? 'true' : 'false'}
          title="Текущие заказы"
        >
          <OrdersSvg />
          <span>{list.length}</span>
        </a>
        {open && (
          <div className="ng-header__orders-panel">
            <div className="ng-header__orders-title">
              {list.length > 1 ? 'Текущие заказы' : 'Текущий заказ'}
            </div>
            {/* Карточка ведёт на страницу заказа обычной ссылкой: шапка живёт
                на любой странице, а hash-роутер работает только внутри /profile. */}
            <ActiveOrderList orders={list} hrefFor={(o) => '/profile#order/' + o.id} />
            <a className="ng-header__orders-all" href="/profile#orders">Все заказы</a>
          </div>
        )}
      </div>
    );
  }
}

// Грузовик доставки — в одном ключе с остальными иконками шапки:
// 16×16, stroke currentColor, без заливки.
function OrdersSvg() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 3h11v13H1z" />
      <path d="M12 8h4.5L21 12v4h-9" />
      <circle cx="7" cy="19" r="2" />
      <circle cx="17" cy="19" r="2" />
    </svg>
  );
}

export const HeaderOrders = observer(HeaderOrdersView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/HeaderOrders.jsx